import http from 'axios'

const instance = {
  _isLoggedIn: false,
  _isStatusChecked: false,
  _clientData: {},

  _checkStatus () {
    return http.get('authOp.php?action=getClientData')
      .then(res => {
        this._isStatusChecked = true
        if (res.data.auth_is_full === 't') {
          this._isLoggedIn = true
          this._clientData = res.data
        }
      },
      () => {
        this._isStatusChecked = true
        this._isLoggedIn = false
        this._clientData = {}
      }
      )
  },

  isLoggedIn () {
    return new Promise((resolve, reject) => {
      if (this._isStatusChecked) resolve(this._isLoggedIn)
      else {
        this._checkStatus()
          .then(
            () => { resolve(this._isLoggedIn) },
            () => { resolve(false) }
          )
          .catch(() => { resolve(false) })
      }
    })
  },

  login ({ client, username, password }) {
    const url = 'nonAuthOp.php?action=login'
    return http.post(url, { client, username, password })
      .then(res => {
        if (res.data !== 'NOT_OK') {
          this._clientData = res.data
          this._isLoggedIn = true
          this._isStatusChecked = true
          return true
        }
        return false
      })
      .catch(() => { return false })
  },

  logout () {
    const url = 'authOp.php?action=logout'
    return http.get(url).then(res => {
      if (res.data === 'OK') {
        this._clientData = {}
        this._isLoggedIn = false
      }
      return res.data === 'OK'
    })
  },

  getClientData () {
    return this._clientData
  }
}

export default instance
